// cookie-settings.js – Immer-Reopen: Footer-Link setzt Widerruf + Reload => Banner erscheint wieder
(function () {
  function wipeConsentAndReload() {
    try {
      // relevante Cookies löschen (breit, aber harmlos)
      var kill = function(name) {
        document.cookie = name + '=; Max-Age=0; path=/;';
        try {
          var host = location.hostname.replace(/^www\./,'');
          document.cookie = name + '=; Max-Age=0; path=/; domain=.' + host + ';';
        } catch(e){}
      };
      // Shopify + gängige CMP Keys
      [
        '_tracking_consent',
        'cookie_consent','cookie-consent','cookieconsent_status',
        'consent_mode','consent_settings','cc_cookie','cc_settings',
        'consentmo','consentmo_status','consentmo_categories'
      ].forEach(kill);

      // evtl. gespeicherte Zustände im Storage löschen
      try {
        Object.keys(localStorage).forEach(function(k){ if (/consent|cookie|cc_|shopifyPrivacy/i.test(k)) localStorage.removeItem(k); });
        Object.keys(sessionStorage).forEach(function(k){ if (/consent|cookie|cc_|shopifyPrivacy/i.test(k)) sessionStorage.removeItem(k); });
      } catch(e){}
    } catch(e){}

    // URL säubern (Parameter entfernen) und neu laden
    try {
      var url = new URL(location.href);
      url.searchParams.delete('cookie-settings');
      history.replaceState(null, document.title, url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
    } catch(e){}
    location.reload();
  }

  // Beim Laden: wenn ?cookie-settings=1 gesetzt ist → direkt widerrufen + reload
  (function handleOnLoad(){
    try {
      var url = new URL(location.href);
      if (url.searchParams.get('cookie-settings') === '1') {
        wipeConsentAndReload();
      }
    } catch(e){}
  })();

  // Zusätzlich: jeden Klick auf Links mit ?cookie-settings=1 abfangen (ohne Seitenwechsel)
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/\bcookie-settings=1\b/i.test(href)) return;
    e.preventDefault();

    // setze den Param in die aktuelle URL (sauber für Back/Forward), dann widerrufen + reload
    try {
      var url = new URL(location.href);
      url.searchParams.set('cookie-settings','1');
      history.replaceState(null, document.title, url.toString());
    } catch(e){}
    wipeConsentAndReload();
  }, true);
})();
